<template>
  <v-app-bar app color="primary" dark>
    <div class="d-flex align-center">
      <v-img
        v-if="$cfg.nstda"
        width="200"
        :src="require(`@/assets/img/logos/logo.png`)"
        style="cursor: pointer"
        @click="
          $route.name !== 'DashboardMenu'
            ? $router.push({
                name: 'DashboardMenu',
              })
            : () => {}
        "
      />
      <div v-else>
        <H3
          v-if="!isMobile"
          style="cursor: pointer"
          @click="
            $route.name !== 'DashboardMenu'
              ? $router.push({
                  name: 'DashboardMenu',
                })
              : () => {}
          "
          ><v-icon v-if="onLine">mdi-wifi</v-icon
          ><v-icon v-else color="grey lighten-1">mdi-wifi-off</v-icon> NOOB IoT
          Dashboard</H3
        >
        <H3
          v-else
          style="cursor: pointer"
          @click="
            $route.name !== 'DashboardMenu'
              ? $router.push({
                  name: 'DashboardMenu',
                })
              : () => {}
          "
          ><v-icon v-if="onLine">mdi-wifi</v-icon
          ><v-icon v-else color="grey lighten-1">mdi-wifi-off</v-icon> NIoT</H3
        >
      </div>
    </div>
    <v-spacer />
    <div style="cursor: pointer" @click="alert" v-if="!isMobile">
      <v-icon>mdi-account</v-icon>
      {{ $auth.name() }}
    </div>

    <v-btn icon @click="fullScreen" v-if="!isMobile">
      <v-icon>mdi-fullscreen</v-icon>
    </v-btn>

    <!-- <v-tooltip v-on="on" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          rounded
          v-bind="attrs" 
          v-on="on"
          @click="fullScreen"
        >
          <v-icon class="pa-1" size="24">mdi-fullscreen</v-icon>
        </v-btn>
      </template>
      <span>{{ isFullscreen ? "ออกจากเต็มหน้าจอ" : "เต็มหน้าจอ"}}</span>
    </v-tooltip> -->

    <v-menu
      v-if="isMobile"
      offset-y
      bottom
      origin="center center"
      transition="scale-transition"
    >
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-if="isMobile">
          <v-list-item-title>
            <v-icon class="pr-2"> mdi-account </v-icon>
            <span> {{ $auth.name() }} </span>
          </v-list-item-title>
        </v-list-item>

        <v-list-item @click="fullScreen">
          <v-list-item-title>
            <v-icon class="pr-2"> mdi-fullscreen </v-icon>
            <span>
              {{ isFullscreen ? "ออกจากเต็มหน้าจอ" : "เต็มหน้าจอ" }}
            </span>
          </v-list-item-title>
        </v-list-item>

        <v-list-item @click="aboutDialog = true">
          <v-list-item-title>
            <v-icon class="pr-2"> mdi-information </v-icon>
            <span> เกี่ยวกับ </span>
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="$auth.isAdmin()"
          @click="$router.push({ name: 'Admin' })"
        >
          <v-list-item-title>
            <v-icon class="pr-2"> mdi-account-tie </v-icon>
            <span> ผู้ดูแลระบบ </span>
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click="$router.push({ name: 'DashboardList' })">
          <v-list-item-title>
            <v-icon class="pr-2"> mdi-view-dashboard-edit </v-icon>
            <span> แผงควบคุม </span>
          </v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item @click="dialog = true">
          <v-list-item-title>
            <v-icon class="pr-2"> mdi-account-multiple </v-icon>
            <span> เปลี่ยนรหัสผ่าน </span>
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click="logout">
          <v-list-item-title>
            <v-icon class="pr-2"> mdi-open-in-new </v-icon>
            <span> ลงชื่อออกจากการใช้งาน </span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <vue-internet-checker @wifi_status="wifi_status" />
    <!-- about -->
    <v-dialog
      persistent
      v-model="aboutDialog"
      transition="dialog-top-transition"
      max-width="300"
    >
      <v-card class="card-shadow border-radius-xl">
        <v-card-title class="mt-0">
          <h5 class="text-h6 font-weight-bold text-typo">เกี่ยวกับ</h5>
          <v-spacer />
          <v-btn class="ma-0" fab icon @click="aboutDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>รุ่น</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>2.5.0</v-list-item-action>
            </v-list-item>
            <v-divider />
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>ผู้พัฒนา</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>สิทธิพงษ์ จันทร์สรณ์</v-list-item-action>
            </v-list-item>
            <v-divider />
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Email</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>db4linq@gmail.com</v-list-item-action>
            </v-list-item>
            <v-divider />
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>โทรศัพท์</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>0863219053</v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- change password -->
    <v-dialog
      persistent
      v-model="dialog"
      transition="dialog-top-transition"
      max-width="600"
    >
      <v-form ref="form" v-model="valid">
        <v-card class="card-shadow border-radius-xl" id="change">
          <v-card-title class="mt-0">
            <h5 class="text-h5 font-weight-bold text-typo">Change Password</h5>
            <v-spacer />
            <v-btn class="ma-2" fab icon @click="close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <div class="px-6 pb-6 pt-0">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Current password"
                  outlined
                  dense
                  type="password"
                  class="font-size-input input-style py-0"
                  v-model="editedItem.password"
                  :rules="[rules.required]"
                ></v-text-field>
                <v-text-field
                  label="New password"
                  outlined
                  dense
                  type="password"
                  class="font-size-input input-style py-0"
                  v-model="editedItem.newPassword"
                  :rules="[rules.required]"
                ></v-text-field>
                <v-text-field
                  label="Confirm new password"
                  outlined
                  dense
                  type="password"
                  class="font-size-input input-style py-0"
                  :rules="[
                    rules.required,
                    rules.confirmPassword(
                      editedItem.newPassword,
                      editedItem.confirmPassword
                    ),
                  ]"
                  v-model="editedItem.confirmPassword"
                ></v-text-field>
              </v-col>
            </v-row>

            <h5 class="mt-5 mb-2 text-h5 font-weight-bold text-typo">
              Password requirements
            </h5>
            <p class="text-muted font-weight-light mb-2">
              Please follow this guide for a strong password:
            </p>
            <div class="d-sm-flex">
              <ul class="text-muted ps-6 mb-0">
                <li>
                  <span class="text-sm">One special characters</span>
                </li>
                <li>
                  <span class="text-sm">Min 6 characters</span>
                </li>
                <li>
                  <span class="text-sm">One number (2 are recommended)</span>
                </li>
                <li>
                  <span class="text-sm">Change it often</span>
                </li>
              </ul>
              <v-btn
                color="#cb0c9f"
                class="font-weight-bolder btn-default bg-gradient-success py-4 px-8 ms-auto mt-sm-auto mt-4"
                small
                @click="save"
              >
                Update password
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-form>
      <v-snackbar v-model="snackbar.show" :color="snackbar.color">
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-dialog>
  </v-app-bar>
</template>
<script>
import Rules from "@/InputValidateRules";
export default {
  name: "DashboardCoreAppBar",
  data: () => ({
    aboutDialog: false,
    isMobile: false,
    onLine: navigator.onLine,
    dialog: false,
    valid: false,
    rules: Rules.rules,
    editedItem: {},
    snackbar: {
      show: false,
      text: "",
      color: "success",
    },
    isFullscreen: false,
  }),
  // beforeDestroy() {
  //   if (typeof window === "undefined") return;
  //   window.removeEventListener("resize", this.onResize, { passive: true });
  //   window.removeEventListener("online", this.updateOnlineStatus);
  //   window.removeEventListener("offline", this.updateOnlineStatus);
  // },
  // created() {
  //   this.$mqtt.on("close", () => {
  //     console.log("mqtt closed");
  //   });
  //   this.$mqtt.on("connect", () => {
  //     console.log("mqtt connected");
  //   });
  // },
  computed: {},
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
    // window.addEventListener("online", this.updateOnlineStatus);
    // window.addEventListener("offline", this.updateOnlineStatus);
    var _this = this;
    document.addEventListener("fullscreenchange", function () {
      console.log("fullscreenchange");
      //_this.isFullscreen = !_this.isFullscreen
    });
  },
  // watch: {
  //   onLine(v) {
  //     if (v) {
  //       console.log("Online");
  //       if (this.snackbar.show === true) {
  //         this.snackbar.show = false;
  //       }
  //     } else {
  //       console.log("Offline");
  //       this.snackbar.text = "คุณออฟไลน์อยู่";
  //       this.snackbar.color = "red";
  //       this.snackbar.timeout = -1;
  //       this.snackbar.show = true;
  //     }
  //   },
  // },
  methods: {
    // updateOnlineStatus(e) {
    //   const { type } = e;
    //   this.onLine = type === "online";
    // },
    fullScreen() {
      // this.$emit("fullScreen");
      let doc = window.document;
      let docEl = doc.documentElement;

      let requestFullScreen =
        docEl.requestFullscreen ||
        docEl.mozRequestFullScreen ||
        docEl.webkitRequestFullScreen ||
        docEl.msRequestFullscreen;
      let cancelFullScreen =
        doc.exitFullscreen ||
        doc.mozCancelFullScreen ||
        doc.webkitExitFullscreen ||
        doc.msExitFullscreen;

      if (
        !doc.fullscreenElement &&
        !doc.mozFullScreenElement &&
        !doc.webkitFullscreenElement &&
        !doc.msFullscreenElement
      ) {
        requestFullScreen.call(docEl);
        this.isFullscreen = true;
      } else {
        cancelFullScreen.call(doc);
        this.isFullscreen = false;
      }
    },
    about() {},
    async save() {
      this.$refs.form.validate();
      console.log("VALID> ", this.valid);
      if (this.valid) {
        const result = await this.$auth.changePassword({
          _id: this.$auth.id(),
          oldPassword: this.editedItem.password,
          newPassword: this.editedItem.newPassword,
        });
        if (result) {
          this.snackbar.text =
            "เปลี่ยนรหัสผ่านสำเร็จ จะทำการลงชื่อเข้าใช้งานใหม่";
          this.snackbar.color = "success";
          this.snackbar.show = true;
        } else {
          this.snackbar.text = "เปลี่ยนรหัสผ่านไม่สำเร็จ";
          this.snackbar.color = "error";
          this.snackbar.show = true;
        }
      }
    },
    async close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.$refs.form.reset();
      });
    },
    wifi_status(e) {
      console.log("AppBar::wifi_status");
      this.onLine = e;
    },
    alert() {
      console.log("xxxxx");
    },
    onResize() {
      this.isMobile = window.innerWidth < 600;
    },
    logout() {
      this.$auth.logout();
    },
  },
};
</script>